import { stringify } from 'qs';

interface Options {
  skipNulls?: boolean;
}

export function urlWithParams(url: string, params?: any, options?: Options) {
  const fullOptions = {
    ...options,
    addQueryPrefix: true,
  };
  return `${url}${stringify(params, fullOptions)}`;
}
